import { useRequestProfileContext } from '../../../RequestProfile.hooks'
import { REQUEST_PROFILE_ACTIONS_WIDGET_NOTIFICATION_TITLE_KEY } from '../../RequestProfileActionsWidget.constants'

export function useRequestProfileToggleVisibleToDwellers() {
  const { handleUpdateEntity, requestData } = useRequestProfileContext()

  function handleClickToggleVisibleToDwellers() {
    const nextValue = !requestData.visibleToDwellers

    handleUpdateEntity(
      { visible_to_dwellers: nextValue },
      nextValue
        ? REQUEST_PROFILE_ACTIONS_WIDGET_NOTIFICATION_TITLE_KEY.showForDwellers
        : REQUEST_PROFILE_ACTIONS_WIDGET_NOTIFICATION_TITLE_KEY.hideForDwellers
    )
  }

  return { handleClickToggleVisibleToDwellers }
}
